import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from '@wegroup/design-system';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InsuranceDetailFormValues } from '../../../../../types/Form';
import useRiskObjectInputStore from '@parties/src/features/risk-objects/store/riskObjectInputStore';

const AddInsuranceModalCoverageExtraFields: React.FC = () => {
  const { t } = useTranslation();
  const setFocusedInput = useRiskObjectInputStore(
    (state) => state.setFocusedInput,
  );
  const {
    register,
    formState: { errors },
  } = useFormContext<InsuranceDetailFormValues>();

  const noteError = errors?.description?.message || '';

  return (
    <FormControl isInvalid={!!noteError} gridColumn="1/-1">
      <FormLabel>{t('ADDITIONAL-REMARKS')}</FormLabel>
      <Textarea
        {...register(`description`, { onBlur: () => setFocusedInput(null) })}
        minH="20"
        onFocus={() => setFocusedInput('description')}
      />
      {noteError && <FormErrorMessage>{t(noteError)}</FormErrorMessage>}
    </FormControl>
  );
};

export default AddInsuranceModalCoverageExtraFields;
